<template>
    <div class="survey-major-container">
        <div class="card-container">
            <el-form inline :model="form">
                <el-form-item>
                    <el-button type="primary" @click="loadData" :loading="loading">查询</el-button>
                    <el-button type="success" @click="handleExport">导出</el-button>
                </el-form-item>
            </el-form>

            <div class="data-table-wrapper">
                    <div class="data-table-body">
                        <h3 class="table-title">近一级各专业（大类）招生报到情况（时点）（表 6-3-3）</h3>
                        <el-table :data="tableData" border style="margin-top: 20px;" :header-cell-style="{background:'#f5f7fa', color:'#606266', fontWeight: '600'}">
                            <el-table-column type="index" label="序号" min-width="60" align="center"></el-table-column>
                            <el-table-column prop="majorName" label="校内专业（大类）名称" min-width="200" align="center"></el-table-column>
                            <el-table-column prop="majorCode" label="校内专业（大类）代码" min-width="180" align="center"></el-table-column>
                            <el-table-column prop="province" label="省份" min-width="120" align="center"></el-table-column>
                            <el-table-column prop="planCount" label="招生计划数" min-width="120" align="center"></el-table-column>
                            <el-table-column prop="admitCount" label="实际录取数" min-width="120" align="center"></el-table-column>
                            <el-table-column prop="firstCount" label="第一志愿专业录取数" min-width="180" align="center"></el-table-column>
                            <el-table-column prop="reportCount" label="实际报到人数" min-width="120" align="center"></el-table-column>
                        </el-table>
                    </div>
                </div>
        </div>
    </div>
</template>

<script>
import { TYBM_Env } from '../../env.js';
import { TYBM_Tools } from '../../tools.js';

export default {
    name: 'SurveyMajor',
    inject: ['getCurrentYear'],
    data() {
        return {
            form: {},
            tableData: [],
            loading: false,
            year: 0
        };
    },
    methods: {
        loadData() {
            const that = this;
            that.loading = true;
            const api_name = '/Survey/GetSurveyMajorData';
            const url = TYBM_Env.GetApiUrl(api_name);

            TYBM_Tools.AxiosGetEx(that, api_name, url, { loading_msg: '正在加载数据' })
                .then(result => {
                    that.tableData = result.data.List;
                    that.year = result.data.Year;
                })
                .catch(() => {
                    that.$message.error('加载数据失败');
                })
                .finally(() => {
                    that.loading = false;
                });
        },
        handleExport() {
            const that = this;
            if (that.tableData.length === 0) {
                that.$message.warning('没有数据可导出');
                return;
            }

            let csvContent = "\uFEFF";
            const headers = ["序号", "校内专业（大类）名称", "校内专业（大类）代码", "省份", "招生计划数", "实际录取数", "第一志愿专业录取数", "实际报到人数"];
            csvContent += headers.join(",") + "\n";

            that.tableData.forEach((row, index) => {
                const rowData = [
                    index + 1, row.majorName, row.majorCode, row.province, row.planCount, row.admitCount, row.firstCount, row.reportCount
                ];
                csvContent += rowData.join(",") + "\n";
            });

            const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement("a");
            const url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download", `各专业招生报到情况_${that.year}.csv`);
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        onYearChange() {
            this.loadData();
        }
    },
    created() {
        this.$root.$on('global-year-change', this.onYearChange);
    },
    beforeDestroy() {
        this.$root.$off('global-year-change', this.onYearChange);
    },
    mounted() {
        this.loadData();
    }
};
</script>

<style scoped>
.survey-major-container {
    width: 100%;
}

.table-title {
    text-align: center;
    margin-bottom: 15px;
    font-size: 16px;
    color: #303133;
}

.data-table-wrapper {
    background: white;
    border-radius: 8px;
    overflow-x: auto;
    overflow-y: auto;
    max-height: calc(100vh - 520px);
    padding: 10px;
}

.data-table-wrapper::-webkit-scrollbar {
    width: 10px;
    height: 10px;
}

.data-table-wrapper::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 5px;
}

.data-table-wrapper::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 5px;
}

.data-table-wrapper::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
}

.data-table-body {
    width: max-content;
    min-width: 100%;
}

.data-table-body >>> .el-table {
    font-size: 13px;
}

.data-table-body >>> .el-table th,
.data-table-body >>> .el-table td {
    padding: 8px 0 !important;
}

.data-table-body >>> .el-table th {
    background-color: #f5f7fa !important;
    color: #606266;
    font-weight: 600;
}

.data-table-body >>> .el-table__row:hover {
    background-color: #f5f9ff;
}
</style>

